const moment = require('moment');

export function parseMail(message) {
  try {
    const from = message.sender;
    const subject = message.subject;
    let params;
    if (from.match('sender@messages.homeaway.com') || from.match('enquiries@ownersdirect.co.uk')) {
      if (subject.match('Abritel')) {
        if (subject.match('Demande de renseignement')) { params = parseAbritel(message, false); }
        if (subject.match('demande de réservation')) { params = parseAbritel(message, true); }
      }
      if (subject.match('VRBO.com')) {
        params = parseVRBO(message);
      }
      if (subject.match('OwnersDirect')) {
        params = parseOwnersDirect(message);
      }
      if (subject.match('Homelidays.es')) {
        params = parseHomelidays(message);
      }
    }
    if (from.match('enquiry@spain-holiday.com') || from.match('noreply@spain-holiday.com')) {
      params = parseSpainHolidays(message);
    }
    if (from.match('inquiry@vacationhomerentals.com')) {
      params = parseVacationRentals(message);
    }
    if (!params) {
      return {
        inquiry: {
          property: { $type: 'reference', external: true, value: ['properties', null] },
          customer: { $type: 'reference', external: true, value: ['customers', null] },
        },
        client: {},
      };
    }
    params.inquiry.creation_date = message.date;
    params.inquiry.customer = { $type: 'reference', external: true, value: ['customers', null] };
    params.inquiry.customer_data = params.client;
    return params;
  } catch (e) {
    console.error('Error while parsing message', e);
    return {
      inquiry: {
        property: { $type: 'reference', external: true, value: ['properties', null] },
        customer: { $type: 'reference', external: true, value: ['customers', null] },
      },
      client: {},
    };
  }
}

export function parseAbritel(message, forBooking = false) {
  const text = message.body.replace(/(\s*(<([^>]+)>)+\s*)+/ig, ' ');
  // console.log('parseAbritel', text);
  let origin;
  let regex;
  if (!forBooking) {
    origin = 'abritel.fr';
    regex = /Indentifiant .* #(.*) Logement .* Dates Disponible ([^, ]*) .* (.*) adulte(?:.?), (.*) enfant(?:.?) Nom du vacancier (.*) Demande de .* Message de (.*) Répondez depuis/;
  } else {
    origin = 'Abritel Online';
    regex = /Location #(.*) Référence .* Dates ([^, ]*) .* (.*) adulte(?:.?), (.*) enfant Nom du vacancier (.*) Méthode de paiement (.*)/;
  }
  const [_foo, propertyId, dates, nb_adults, nb_children, stringName, stringMsg] = regex.exec(text) || [];
  let property = { $type: 'reference', external: true, value: ['properties', null] };;
  switch (propertyId) {
  case '601994':
    property = { $type: 'reference', external: true, value: ['properties', '705046096607449088'] }; // Sant Pau 3
    break;
  case '602051':
    property = { $type: 'reference', external: true, value: ['properties', '705046096691335168'] }; // Corcega
    break;
  case '610011':
  case '614011':
    property = { $type: 'reference', external: true, value: ['properties', '705046096552923136'] }; // Sant Pau 1
    break;
  }
  const [arrivalDate, departureDate] = dates.split('-');
  let displayName = stringName;
  let phone;
  if (stringName.match('Numéro de téléphone')) {
    [displayName, phone] = stringName.split('Numéro de téléphone du vacancier');
  }
  let msg = '';
  if (stringMsg.match('Message du vacancier')) {
    msg = stringMsg.split('Message du vacancier')[1].split('Votre devis')[0];
  }
  return {
    client: {
      display_name: (displayName || '').trim()
    },
    inquiry: {
      property, nb_adults, nb_children, origin,
      arrival_date: arrivalDate ? moment(arrivalDate, 'DD/MM/YY').format('YYYY-MM-DD') : '',
      departure_date: departureDate ? moment(departureDate, 'DD/MM/YY').format('YYYY-MM-DD') : '',
      message: !forBooking ? msg.split(displayName)[1] : msg,
    }
  };
}

export function parseVRBO(message) {
  const text = message.body.replace(/(\s*(<([^>]+)>)+\s*)+/ig, ' ');
  const origin = 'VRBO';
  const regex = /Property #(.*) Dates Available (.*)- .*, (.*) , (.*) nights.*Guests (.*) adults, (.*) children Traveler name (.*) Inquiry from/;
  const [_foo, propertyId, arrivalDay, year, nbNights, nb_adults, nb_children, display_name] = regex.exec(text) || [];
  const arrivalDate = moment(`${arrivalDay} ${year}`, 'MMM DD YYYY');
  const departureDate = moment(arrivalDate).add(nbNights, 'days');
  const regexMessage = `Message from ${display_name} (.*) Review this Inquiry`;
  const [_, msg] = new RegExp(regexMessage).exec(text) || [];
  // console.log('DATE', arrivalDate.format('YYYY-MM-DD'), departureDate.format('YYYY-MM-DD'));
  let property = { $type: 'reference', external: true, value: ['properties', null] };
  switch (propertyId) {
  case '79006':
    property = { $type: 'reference', external: true, value: ['properties', '705046096594866176'] }; // Sant Pau 2
    break;
  case '74574':
    property = { $type: 'reference', external: true, value: ['properties', '705046096691335168'] }; // Corcega
    break;
  case '73784':
    property = { $type: 'reference', external: true, value: ['properties', '705046096607449088'] }; // Sant Pau 3
    break;
  }
  return {
    client: {
      display_name
    },
    inquiry: {
      property, nb_adults, nb_children, origin,
      arrival_date: arrivalDate ? arrivalDate.format('YYYY-MM-DD') : '',
      departure_date: departureDate ? departureDate.format('YYYY-MM-DD') : '',
      message: msg,
    }
  };
}

export function parseOwnersDirect(message) {
  const text = message.text;
  const origin = 'Owners Direct';
  // console.log('parseOwnersDirect', text);
  const regex = /Holidaymaker name:\s*(.*)\s*View[\S\s]*Arrival date:\s*(.*)\s*Departure date:\s*(.*)\sGuests:\s*(.*) adult(?:.?), (.*) child(?:.*)\s*Further information:\s*([\S\s]*)\n\n\n.+ to .+ is AVAILABLE/;
  const parsingResult = regex.exec(text) || [];
  if (!parsingResult) return;
  const [_foo, display_name, arrivalDate, departureDate, nb_adults, nb_children, msg] = parsingResult;
  const property = { $type: 'reference', external: true, value: ['properties', '705046096661975040'] }; // Sant Pau 6
  return {
    client: {
      display_name
    },
    inquiry: {
      property, nb_adults, nb_children, origin,
      arrival_date: arrivalDate ? moment(new Date(arrivalDate)).format('YYYY-MM-DD') : '',
      departure_date: departureDate ? moment(new Date(departureDate)).format('YYYY-MM-DD') : '',
      message: msg,
    }
  };
}

export function parseHomelidays(message) {
  const text = message.body.replace(/(\s*(<([^>]+)>)+\s*)+/ig, ' ');
  const origin = 'Homelidays';
  const regex = /Fechas Disponible ([^, ]*) , .* (.*) adulto(?:.?), (.*) niño(?:.?) Nombre del viajero (.*) Solicitud de .* Mensaje de (.*) Reponder desde/;
  const parsingResult = regex.exec(text) || [];
  if (!parsingResult) return;
  const [_foo, dates, nb_adults, nb_children, display_name, msg] = parsingResult;
  const [arrivalDate, departureDate] = dates.split('-');
  const property = { $type: 'reference', external: true, value: ['properties', '705046096607449088'] }; // Sant Pau 3
  return {
    client: {
      display_name
    },
    inquiry: {
      property, nb_adults, nb_children, origin,
      arrival_date: arrivalDate ? moment(arrivalDate, 'DD/MM/YY').format('YYYY-MM-DD') : '',
      departure_date: departureDate ? moment(departureDate, 'DD/MM/YY').format('YYYY-MM-DD') : '',
      message: msg.split(displayName)[1],
    }
  };
}

export function parseSpainHolidays(message) {
  const text = message.text;
  const origin = 'Spain Holiday';
  const regex = /nueva petición.\s*([0-9]*)[\S\s]*\*Fechas del viaje\*\s*(.*) \([\S\s]*\*Personas\*\s*(.*) adulto(?:.?), (.*) niño(?:.?)\s*\*Petición\*\s*([\S\s]*)\*Inquilino\*\s*(.*)[\S\s]*(?:mailto:([^\]]*))/;
  const parsingResult = regex.exec(text) || [];
  if (!parsingResult) return;
  const [_foo, propertyId, dates, nb_adults, nb_children, msg, display_name, email] = parsingResult;
  let [arrivalDate, departureDate] = dates.split('-');
  const arrivalMonth = arrivalDate.match(/[a-z]+/)[0];
  const departureMonth = departureDate.match(/[a-z]+/)[0];
  arrivalDate = arrivalDate.replace(arrivalMonth, translateMonth(arrivalMonth));
  departureDate = departureDate.replace(departureMonth, translateMonth(departureMonth));
  let property = { $type: 'reference', external: true, value: ['properties', null] };;
  switch (propertyId) {
  case '26179':
    property = { $type: 'reference', external: true, value: ['properties', '705046098473914368'] }; // Corcega 2
    break;
  case '6882':
    property = { $type: 'reference', external: true, value: ['properties', '705046096607449088'] }; // Sant Pau 3
    break;
  }
  return {
    client: {
      display_name,
      email
    },
    inquiry: {
      origin, property, nb_adults, nb_children,
      arrival_date: arrivalDate ? moment(new Date(arrivalDate)).format('YYYY-MM-DD') : '',
      departure_date: departureDate ? moment(new Date(departureDate)).format('YYYY-MM-DD') : '',
      message: msg,
    }
  };
}

export function parseVacationRentals(message) {
  const text = message.body.replace(/(\s*(<([^>]+)>)+\s*)+/ig, ' ');
  const origin = 'Vacation Home Rental';
  const regex = /Inquiry Detail (.*) Name: (.*) Requested Dates: (.*) Guests: (.*) guests .* Email: (.*) Quick Links/;
  const parsingResult = regex.exec(text) || [];
  if (!parsingResult) return;
  const [_foo, msg, display_name, dates, nb_adults, email] = parsingResult;
  const [arrivalDate, departureDate] = dates.split('-');
  const property = { $type: 'reference', external: true, value: ['properties', '705046096607449088'] }; // Sant Pau 3
  return {
    client: {
      display_name,
      email
    },
    inquiry: {
      origin, property, nb_adults, nb_children: 0,
      arrival_date: arrivalDate ? moment(new Date(arrivalDate)).format('YYYY-MM-DD') : '',
      departure_date: departureDate ? moment(new Date(departureDate)).format('YYYY-MM-DD') : '',
      message: msg,
    }
  };
}

function translateMonth(month) {
  const months = {
    january: 'janvier janv. janv enero ene',
    february: 'février févr. févr feb',
    march: 'mars mars marzo mar',
    april: 'avril avr. avr abr',
    may: 'mai mayo may',
    june: 'juin jun',
    july: 'juillet juil. juill. jul',
    august: 'août aug agosto ago',
    september: 'septembre sept. sept set',
    october: 'octobre oct. oct',
    november: 'novembre nov. nov',
    december: 'décembre déc. dic',
  };
  let englishMonth;
  Object.keys(months).some(enMonth => {
    if (months[enMonth].match(month)) {
      englishMonth = enMonth;
      return true;
    }
  });
  return englishMonth;
}



// WEBPACK FOOTER //
// ./src/backend/email/api/parsing.js